module.exports = __webpack_public_path__ + "img/7.329a6194.svg";